import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Cover from '../components/cover/cover'
import Layout from "../components/layout"
import SEO from "../components/seo"
import TeamTile from '../components/team-tile/team-tile'

import cover from "../images/team-cover-alt.jpg"

const TeamPage = () => {

    const data = useStaticQuery(graphql`
    query {
        allContentfulTeam {
            nodes {
              about {
                about
              }
              image {
                file {
                  url
                }
              }
              id
              name
              role
              chapter
            }
          }
        }
    `)
    
    return (
  <Layout>
    <SEO title="We Clothe Them - Team" />
    <Cover image={cover} title={`Our Team`} />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading`}>Our Team</h6>
        <h2>Who We Are</h2>
        <p>
          We are young change-makers who are doing our tiny bit to empower the
          less privileged by the simple concept of redirecting clothes from
          where they are in excess and no longer in use to where they are
          actually needed, and ensuring they are finally used.
        </p>
      </div>
    </section>
    <section className={`grey sm`}>
      <div className={`content`}>
        <div
          className={`flex cofounders-team`}
          style={{ flexWrap: "wrap", justifyContent: "center" }}
        >
          {data.allContentfulTeam.nodes.map((node)=>{
              if(node.role === 'Co-Founder') {
                return (
                    <TeamTile 
                        name={node.name}
                        role={node.role}
                        image={node.image.file.url}
                        about={node.about? node.about.about : ''}
                    />
                )
              }
          })}
        </div>
        <div
          className={`flex`}
          style={{ flexWrap: "wrap", justifyContent: "center" }}
        >
          {data.allContentfulTeam.nodes.map((node)=>{
              if(node.role !== 'Co-Founder') {
                return (
                    <TeamTile 
                        name={node.name}
                        role={node.role}
                        image={node.image.file.url}
                        chapter={node.chapter}
                        about={node.about? node.about.about : ''}
                    />
                )
              }
          })}
        </div>
      </div>
    </section>
  </Layout>
    )
}

export default TeamPage